import { render } from "./Quil-editor.vue?vue&type=template&id=6f2bd658"
import script from "./Quil-editor.vue?vue&type=script&lang=js"
export * from "./Quil-editor.vue?vue&type=script&lang=js"

import "./Quil-editor.vue?vue&type=style&index=0&id=6f2bd658&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__